import { c as _c } from "react/compiler-runtime";
import { getCardListItems, type LpCardListNote } from '@cc-shopping/contracts/credit-cards-page/landing-page/CreditCardsLPCardList';
import type { StructuredContentDocument } from '@cc-shopping/structured-content-renderer/hydration/types';
import { Box, Typography } from '@mui/material';
import { BenefitCards } from 'src/features/ChaseLandingPages/ui/sections/Content/AdditionalBenefits/BenefitCards';
import { FinePrint } from 'src/features/ChaseLandingPages/ui/sections/Content/AdditionalBenefits/FinePrint';
import { OtherPerks } from 'src/features/ChaseLandingPages/ui/sections/Content/AdditionalBenefits/OtherPerks';
import { SectionTitle } from 'src/features/ChaseLandingPages/ui/sections/components/SectionTitle';
const ANCHOR_PREFIX = 'additional-benefits';
export type CreditCardsLPCardListProps = StructuredContentDocument<{
  title?: string;
  subtitle?: string;
  cardType?: string;
  notes?: LpCardListNote[];
  children?: StructuredContentDocument[];
}>;
export const CreditCardsLPCardList = t0 => {
  const $ = _c(23);
  const {
    props
  } = t0;
  let t1;
  if ($[0] !== props.children) {
    t1 = getCardListItems(props.children);
    $[0] = props.children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  if (!items.length) {
    return null;
  }
  if (props.cardType === "perk") {
    let t2;
    if ($[2] !== items || $[3] !== props.title) {
      t2 = <OtherPerks title={props.title} items={items} />;
      $[2] = items;
      $[3] = props.title;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "column",
      gap: 3,
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center"
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.title) {
    t3 = props.title && <SectionTitle color="blues.darkest">{props.title}</SectionTitle>;
    $[6] = props.title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props.subtitle) {
    t4 = props.subtitle && <Typography sx={{
      color: "blues.dark",
      fontSize: 18,
      fontWeight: "lighter"
    }}>{props.subtitle}</Typography>;
    $[8] = props.subtitle;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <Box sx={t2}>{t3}{t4}</Box>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== items) {
    t6 = <BenefitCards anchorPrefix={ANCHOR_PREFIX} items={items} />;
    $[13] = items;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== props.notes) {
    t7 = props.notes ?? [];
    $[15] = props.notes;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <FinePrint anchorPrefix={ANCHOR_PREFIX} notes={t7} />;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t8) {
    t9 = <>{t5}{t6}{t8}</>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};